<template>
  <div>
    <section class="page-content">
      <div class="row">
        <div class="col-md-12">
          <form action @submit.prevent="next">

            <article class="d-flex form-heading title-section form-section">
              <p class="form-title text-center" style="font-size: 35px;">
                NO KNOWN LOSS LETTER
              </p>
            </article>
            <article class="input-section form-section">

              <div class="pt-0">
                <div class="row pb-3">
                  <div class="col-md-6">
                    <label for class="orep-label mb-0 ml-1">
                      Company Name:
                    </label>
                    <div class="d-flex flex-column">
                      <input
                        type="text"
                        v-model="ppiApplication.nameOfApplicant"
                        class="orep-text-input w-100"
                        disabled
                      >
                    </div>
                  </div>
                  <div class="col-md-6">
                    <label for class="orep-label mb-0 ml-1">
                      Today’s Date:
                    </label>
                    <div class="d-flex flex-column">
                      <input
                        type="date"
                        class="orep-text-input w-100 text-center"
                        :value="formattedCurrentDate()"
                        disabled
                      >
                      <label for class="orep-label mt-2">
                        (Month/Day/Year)
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <h4>
                RE: Business Owner’s, General Liability and E&O Insurance

              </h4>
              <h6>
                (Including Business Personal Property and Business Income)
              </h6>
              <br/>
              <div>
                <p class="mb-3">
                  We represent that we do not have knowledge of any unfiled claim or suit, nor are we aware of
                  any acts, circumstances, or incidents which we believe could give rise to any claim or suit
                  under the above coverages through today’s Date <strong>{{ CurrentDate() }}</strong>
                </p>
              </div>
              <label for class="orep-label mt-2">
                Sincerely,
              </label>
              <div class="row pb-3">
                <div class="col-md-6">
                  <input
                    type="text"
                    name="nklSignature"
                    placeholder="Type Your Name to Sign"
                    class="orep-text-input w-100"
                    v-model="ppiApplication.nklSignature"
                    v-validate="'required'"
                    @input="validateBeforeSubmit()"
                  >
                  <span
                    v-show="errors.has('nklSignature')"
                    class="help is-danger form-errors text-danger"
                  >{{ errors.first('nklSignature') | filterText }}</span>
                  <label for class="orep-label mt-2">
                    {{ ppiApplication.nameOfApplicant }}
                  </label>
                  <label for class="orep-label mt-2">
                    (Letter must be signed by owner)
                  </label>
                </div>
              </div>
            </article>
          </form>
        </div>
      </div>
    </section>
    <div>
      <div class="row">
        <div class="col-md-12">
          <section class="flex wrap bottom-section">
            <router-link :to="{name:'ppi-application-3'}" class="next-btn back-btn flex mont spaced">
              <i class="fas fa-arrow-left"></i>
              Back
            </router-link>
            <article class="orep-pagination">
              <button class="pagination-dots" @click="navigateToPrev('ppi-application-1')"></button>
              <button class="pagination-dots" @click="navigateToPrev('ppi-application-2')"></button>
              <button class="pagination-dots" @click="navigateToPrev('ppi-application-3')"></button>
              <span class="pagination-dots pagination-current"></span>
              <button class="pagination-dots" :disabled="!state.pageFourIsValid" @click="next('ppi-application-5')"></button>
            </article>
            <button
              class="next-btn mont spaced text-uppercase"
              @click="next('ppi-application-5')"
              :disabled="!state.pageFourIsValid"
              :class="{submitDisabled: !state.pageFourIsValid}"
            >Next</button>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import moment from 'moment';
import {APP_STATUS, STATUS} from "../../utils/constants";

export default {
  name: "ppi-application-4",
  data() {
    return {
      loading: false
    };
  },
  computed: {
    ppiApplication() {
      return this.$store.state.ppiApplication.ppiApplication;
    },
    state() {
      return this.$store.state.ppiApplication;
    },
    errorMsg() {
      return this.$store.state.ppiApplication.errorMsg;
    }
  },
  watch: {
    errorMsg: {
      handler() {
        if (this.errorMsg) {
          this.loading = false;
          this.$notify({
            group: 'error',
            type: 'error',
            title: 'Error',
            text: this.errorMsg
          });
        }
      }
    }
  },
  methods: {
    navigateToPrev(route) {
      this.$router.push({
        name: route
      });
    },
    checkServices(service) {
      return this.ppiApplication.applicantOrAssociateReportMode.includes(service);
    },

    next(routeName) {
      this.$router.push({
        name: routeName
      });
    },
    validateBeforeSubmit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.state.pageFiveIsValid = true;
          return;
        }
        this.state.pageFiveIsValid = false;
      });
    },

    formattedCurrentDate() {
      return moment(this.ppiApplication.applicantPrincipleEsignatureDatetime).format('YYYY-MM-DD');
    },
    CurrentDate() {
      return moment(this.ppiApplication.applicantPrincipleEsignatureDatetime).format('MM/DD/YYYY');
    },
    BusinessDate() {
      return moment.utc(this.ppiApplication.yearOfBusinessEstablishment).format('MM/DD/YYYY');
    },

    formSubmit() {
      this.loading = true;
      this.ppiApplication.status = STATUS.Submitted;
      this.ppiApplication.customer.appStatus = APP_STATUS.Completed;
      this.$store.dispatch('homeInspector/createQuote');
    }

  },


  filters: {
    filterText(x) {
      if (x !== undefined) {
        if (x.indexOf("req") !== -1) {
          return "This field is required";
        } else {
          return x.replace("_", " ");
        }
      }
    }
  },

  mounted() {
    $('html, body').animate({
        scrollTop: $('.orep-header').offset().top
    }, 500);
  },

  components: {}
};
</script>

<style scoped>
  strong {
    text-decoration: underline;
  }
  .form-inline > label {
    width: 82px;
    text-align: left;
  }
  .form-heading > p {
    font-size: 35px;
    width: 100%;
    text-align: center;
    margin: 0;
  }
  .form-errors,
  .js-input-errors {
    display: block;
    text-transform: initial;
    font-size: 13px;
    width: 90%;
    margin: auto;
    position: relative;
    top: -29px;
  }
  fieldset {
    font-size: 12px;
  }
  .logo {
    width: 150px;
    height: 45px;
    object-fit: contain;
  }
  h6 {
    font-size: 14px;
  }
  h5 {
    font-size: 16px;
  }
  .company-info-content {
    padding: 10px 30px;
    border: 1px solid black;
  }
  .fs-subtitle {
    margin: 20px 0;
    border-bottom: 2px solid black;
  }
  table.oreptable {
    font-size: 14px;
    margin-left: auto;
    margin-right: auto;
  }
  .gen-inf {
    display: flex;
    background: #eee none repeat scroll 0 0;
    font-size: 15px;
    font-weight: 700;
    margin-bottom: 20px;
    margin-top: 20px;
    padding: 7px;
    text-align: left;
    height: 30px;
    border: 1px solid black;
  }
  .underline-value {
    margin-left: 10px;
    margin-right: 40px;
    border-bottom: 1px solid black;
    margin-bottom: 15px;
    font-weight: 700;
    font-size: 14px;
  }
  .table th, .table td {
    text-align: center;
    vertical-align: middle;
  }
  .table.ar td, .table.ar th {
    border-left: 1px solid #ddd !important;
    border-top: 1px solid #ddd !important;
    border-right: 1px solid #ddd !important;
  }
  .w-20 {
    width: 20%;
  }
  .blank_th {
    width: 210px;
  }
  .footer-company-info {
    background-color: yellow;
    border: 1px solid black;
    padding: 10px 20px 40px;
  }
  .form-check-input {
    position: relative;
    margin-left: 0;
  }
  .page-content p, .page-content li {
    font-size: 15px;
  }
</style>

